var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-list-container"},_vm._l((_vm.orderedGroups),function(group){return _c('question-group-list',{key:group.id,attrs:{"group":group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }